import { define } from 'wicked-elements'
import fitText from '../lib/fit-text.js'

define('[data-component~="fit-text"]', {
  init () {
    this.sizes = [
      'ch-sans-base',
      'ch-sans-sm',
      'ch-sans-xs'
    ]

    this.reset = [
      'ch-sans-base',
      'ch-sans-sm',
      'ch-sans-xs',
      'md:ch-sans-base'
    ]

    this.render = this.render.bind(this)
    this.resizeObserver = new ResizeObserver(this.render)
    this.render()
  },
  connected () {
    this.resizeObserver.observe(this.element)
  },
  disconnected () {
    this.resizeObserver.disconnect()
  },
  render () {
    fitText(this.element, this.sizes, this.reset)
  }
})